import React from 'react';
import HomeClient from '../../components/HomeClient';

const SalesPage: React.FC = () => {
  return <HomeClient variant="sales" />;
};

export default SalesPage;
